'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

function _getAnchorPositions(target){
const rect=target.getBoundingClientRect();
const halfWidth=rect.width*0.5;
const halfHeight=rect.height*0.5;

const{top,bottom,left,right}=rect;

const positions={
topLeft:{x:left,y:top},
top:{x:left+halfWidth,y:top},
topRight:{x:right,y:top},
right:{x:right,y:top+halfHeight},
bottomRight:{x:right,y:bottom},
bottom:{x:left+halfWidth,y:bottom},
bottomLeft:{x:left,y:bottom},
left:{x:left,y:top+halfHeight},
center:{x:left+halfWidth,y:top+halfHeight}};


return positions;
}

function _getAlignmentOffsets(element,anchor,leftOffset){
const rect=element.getBoundingClientRect();
const fullWidth=rect.width;
const fullHeight=rect.height;
const halfWidth=rect.width*0.5;
const halfHeight=rect.height*0.5;

const{x,y}=anchor;
leftOffset=leftOffset?Number.parseFloat(leftOffset):0;

return{
topLeft:{x:x+leftOffset,y:y},
top:{x:x-halfWidth,y:y},
topRight:{x:x-fullWidth,y:y},
right:{x:x-fullWidth,y:y-halfHeight},
bottomRight:{x:x-fullWidth,y:y-fullHeight},
bottom:{x:x-halfWidth,y:y-fullHeight},
bottomLeft:{x:x+leftOffset,y:y-fullHeight},
left:{x:x+leftOffset,y:y-halfHeight},
center:{x:x-halfWidth,y:y-halfHeight}};

}

function _getTooltipPosition(target,element,anchorSide,alignmentSide,leftOffset,cb){
fastdom.measure(()=>{
if(!_.exists(target)||!_.exists(element)){
return;
}

const anchorPositions=_getAnchorPositions(target);
const anchor=anchorPositions[anchorSide];
const alignedPoints=_getAlignmentOffsets(element,anchor,leftOffset);
cb(alignedPoints[alignmentSide]);
});
}

const _getTooltipHtml=(directive,anchorPosition,alignPosition)=>
`<div class="tooltip-container ${directive}-container anchor-position-${anchorPosition} align-position-${alignPosition}">
		<${directive} class="tooltip-directive-container"/>
	</div>`;let

TooltipService=class TooltipService extends BaseService{
constructor($rootScope,$window,$compile,$timeout){
super();
this._$compile=$compile;
this._tooltipsRoot=angular.element('#tooltips');
this._windowElement=angular.element($window);

this._tooltipsContainer=null;
this._currentTarget=null;
this._scope=null;
this._$timeout=$timeout;

this._repositionTooltip=this._repositionTooltip.bind(this);
this.closeTooltip=this.closeTooltip.bind(this);

$rootScope.$on('resize::resize',this.closeTooltip);
$rootScope.$on('$stateChangeSuccess',this.closeTooltip);
}

get currentTarget(){
return this._currentTarget;
}

updateTooltipPosition(alignmentOptions,target,containerElement){
this._$timeout(()=>{
const{anchorToTargetSide,alignFromTooltipSide,leftOffset}=alignmentOptions;

_getTooltipPosition(target,containerElement[0],anchorToTargetSide,alignFromTooltipSide,leftOffset,({x,y})=>{
fastdom.mutate(()=>_.attempt(()=>containerElement.css({transform:`translate(${x}px, ${y}px)`})));
});
});
}

_repositionTooltip(){
if(!_.allExist(this._currentTarget,this._scope)){
return;
}

fastdom.measure(()=>{
const target=this._currentTarget;
const container=angular.element('#tooltips .tooltip-container');

if(!_.allExist(container,this._scope)){
return;
}

const{anchorToTargetSide,alignFromTooltipSide,leftOffset}=this._scope;

_getTooltipPosition(target,container[0],anchorToTargetSide,alignFromTooltipSide,leftOffset,({x,y})=>{
fastdom.mutate(()=>_.attempt(()=>container.css({transform:`translate(${x}px, ${y}px)`})));
});
});
}

openTooltip(scope,target){
this._currentTarget=target;
this._scope=scope;

const htmlTemplate=_getTooltipHtml(scope.directive,scope.anchorToTargetSide,scope.alignFromTooltipSide);
const compiledHtml=this._$compile(htmlTemplate)(scope);

fastdom.mutate(()=>{
this._tooltipsRoot.html(compiledHtml);

fastdom.measure(()=>{

const tooltipTemplateDirective=this._tooltipsRoot.find(`${scope.directive} .tooltip-body`);
if(tooltipTemplateDirective.length===0)return;

this._setupEventHandlers();

angular.element('#tooltips .tooltip-container .tooltip-directive-container').addClass('open');
this._repositionTooltip();
});
});
}

closeTooltip(){
this._removeEventHandlers();



this._tooltipsRoot.empty();

if(_.exists(this._currentTarget)){
this._currentTarget=null;
}

if(_.exists(this._scope)){
this._scope.$destroy();
this._scope=null;
}
}

_setupEventHandlers(){
this._windowElement.on('click',this.closeTooltip);
this._enableRepositioningOnScroll();
}

_removeEventHandlers(){
this._windowElement.off('click',this.closeTooltip);
this._disableRepositioningOnScroll();
}

_enableRepositioningOnScroll(){
const _scrollbarElement=angular.element('.pulsar-scrollbar');

if(!_.exists(_scrollbarElement)){
return;
}

_scrollbarElement.on('scroll',this._repositionTooltip);
}

_disableRepositioningOnScroll(){
const _scrollbarElement=angular.element('.pulsar-scrollbar');

if(!_.exists(_scrollbarElement)){
return;
}

_scrollbarElement.off('scroll',this._repositionTooltip);
}};


module.exports=TooltipService;
//# sourceMappingURL=tooltipService.js.map
